export default __webpack_public_path__ + "static/media/legend.0f2172e4.webp";